<template>
  <b-container fluid>
    <b-row style="margin-top: 4em">
      <b-col>
        <h2 class="text-info">
          {{ $t("globals.invoices") }}
          <icon v-if="getAllBillingInvoicesLoading" name="spinner" spin></icon>
          <icon
            v-if="getAllScheduledInvoicesLoading"
            name="spinner"
            spin
          ></icon>
          <icon v-if="getAllParkingInvoicesLoading" name="spinner" spin></icon>
        </h2>
      </b-col>
      <b-col>
        <b-btn
          v-if="getUserBrandPermissions.invoice_exact_export"
          class="float-right m-2"
          variant="warning"
          @click="showExportModal = true"
        >
          {{ $t("globals.export_exact") }}
        </b-btn>
        <b-dropdown
          variant="info"
          class="float-right m-2"
          :text="$t('globals.import_exact')"
        >
          <b-dropdown-item
            v-if="getUserBrandPermissions.invoice_exact_import"
            @click="showImportModal = true"
          >
            {{ $t("globals.invoices") }}
          </b-dropdown-item>
          <!--
          <b-dropdown-item
              v-if="getUserBrandPermissions.invoice_exact_import"
              @click="showParkingImportModal = true">
            {{ $t("globals.parking_invoices") }}
          </b-dropdown-item> -->
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab :title="$t('globals.invoices')" active>
            <ulu-invoices-tab />
          </b-tab>
          <b-tab title="Mollie">
            <ulu-mollie-tab />
          </b-tab>
          <b-tab :title="$t('globals.parking_invoices')">
            <ulu-parking-invoices-tab />
          </b-tab>
          <b-tab :title="$t('globals.scheduled_invoices')">
            <ulu-sheduled-invoices-tab />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <ulu-export-exact-modal :show="showExportModal" :close="closeExportModal" />
    <ulu-import-exact-modal :show="showImportModal" :close="closeImportModal" />
    <ulu-import-parking-exact-modal
      :show="showParkingImportModal"
      :close="closeParkingImportModal"
    />
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-invoices-tab": () =>
      import("@/components/invoices/all_invoices/InvoicesTab"),
    "ulu-mollie-tab": () =>
      import("@/components/invoices/all_invoices/MollieTab"),
    "ulu-parking-invoices-tab": () =>
      import("@/components/invoices/all_invoices/ParkingInvoicesTab"),
    "ulu-sheduled-invoices-tab": () =>
      import("@/components/invoices/all_invoices/SheduledInvoicesTab"),
    "ulu-export-exact-modal": () =>
      import("@/components/invoices/all_invoices/ExportExactModal"),
    "ulu-import-exact-modal": () =>
      import("@/components/invoices/all_invoices/ImportExactModal"),
    "ulu-import-parking-exact-modal": () =>
      import("@/components/invoices/all_invoices/ImportParkingExactModal")
  },
  data() {
    return {
      showExportModal: false,
      showImportModal: false,
      showParkingImportModal: false
    };
  },
  methods: {
    closeExportModal() {
      this.showExportModal = false;
    },
    closeImportModal() {
      this.showImportModal = false;
    },
    closeParkingImportModal() {
      this.showParkingImportModal = false;
    }
  },
  computed: {
    ...mapGetters("invoices", [
      "getAllBillingInvoicesLoading",
      "getAllParkingInvoicesLoading"
    ]),
    ...mapGetters([
      "getUserSystem",
      "getUserBrandPermissions",
      "getAllScheduledInvoicesLoading"
    ])
  },
  created() {
    if (!this.getUserBrandPermissions.invoices_index) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>
